export default {"src":"/_next/static/media/logo.997e5fe8.svg","height":257,"width":486};